var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"status-indicator",class:_vm.status,attrs:{"title":_vm.status}})
}
var staticRenderFns = []

export { render, staticRenderFns }